import { React, useState, useEffect } from 'react';
import { useCookies } from "react-cookie";
import { NavLink } from 'react-router-dom';
import styled from "styled-components";
import http from "../../Common/http-common";
import { Nav, Accordion, Dropdown } from "react-bootstrap";
import classes from "./NavBar.module.css";
import { moduleBinary, GetUserAuthorityFn, GetModuleList } from "../../Common/authority";
import * as common from "../../Common/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import { faGrip, faPersonWalkingLuggage, faRectangleList, faNewspaper, faUser, faGears } from "@fortawesome/free-solid-svg-icons";
const PAGE_NAME = "NavBar.js_";

const SideNavBar = styled.nav`
  top: 0;
  left: 0;
  bottom: 0;
  width: ${({ sidebar }) => (sidebar ? "0px" : "235px")};
  min-width: ${({ sidebar }) => (sidebar ? "0px" : "235px")};
  border-right: 1px solid;
	background-color: #222d32;
  font-size: 0.9rem;
  overflow-x: hidden;
  webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s;
`;

function NavBar({ sideNavBar, setSideNavBar, hideBarPages }) {
  const [cookies] = useCookies([]);
  const [moduleCatBinary, setModuleCatBinary] = useState({
    Dashboard: 0b0000000000000000,
    Apply: 0b0000000000000000,
    History: 0b0000000000000000,
    Users: 0b0000000000000000,
    MasterSetup: 0b0000000000000000,
    Public: 0b0000000000000000,
  });

  const [openAccordion, setOpenAccordion] = useState(null);
  const [pendingCounts, setPendingCounts] = useState({});
  const location = useLocation();

  useEffect(() => {
    if (window.innerWidth <= 768) { 
      setSideNavBar(true);
    }
  }, [location]);

  const CatApply = [
    {
      key: "/Leave",
      title: "Leave",
    },
    {
      key: "/Allowance",
      title: "Allowance Claim",
    },
    {
      key: "/Expenses",
      title: "Expenses Claim",
    },
  ]
  
  const CatHistory = [
    {
      key: "/LeaveHistory",
      title: "Leave",
    },
    {
      key: "/AllowanceHistory",
      title: "Allowance Claim",
    },
    {
      key: "/ExpensesHistory",
      title: "Expenses Claim",
    },
  ]

  const CatUser = [
    // {
    //   key: "/profile",
    //   title: "Profile",
    // },
    {
      key: "/employee",
      title: "Employee",
    },
    {
      key: "/role",
      title: "Roles",
    },
    {
      key: "/permission",
      title: "Permissions",
    },
  ]

  const CatMasterSetup = [
    {
      key: "/policy",
      title: "System Policy",
    },
    {
      key: "/entitlements",
      title: "Entitlements",
    },
    {
      key: "/allowancerate",
      title: "Allowance Rate",
    },
  ]

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserAuthorityFn(
        cookies.USER_ID,
        "CAT_DASHBOARD",
        GetModuleList("CAT_DASHBOARD")
      );
    
      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            Dashboard: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            Dashboard: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserAuthorityFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserAuthorityFn(
        cookies.USER_ID,
        "CAT_APPLY",
        GetModuleList("CAT_APPLY")
      );
    
      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            Apply: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            Apply: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserAuthorityFn", error);
        }
      );
    }
  }, [cookies]);
      
  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserAuthorityFn(
        cookies.USER_ID,
        "CAT_HISTORY",
        GetModuleList("CAT_HISTORY")
      );
    
      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            History: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            History: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserAuthorityFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserAuthorityFn(
        cookies.USER_ID,
        "CAT_USERS",
        GetModuleList("CAT_USERS")
      );
    
      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            Users: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            Users: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserAuthorityFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserAuthorityFn(
        cookies.USER_ID,
        "CAT_MASTER",
        GetModuleList("CAT_MASTER")
      );
    
      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            MasterSetup: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            MasterSetup: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserAuthorityFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserAuthorityFn(
        cookies.USER_ID,
        "CAT_PUBLIC",
        GetModuleList("CAT_PUBLIC")
      );
    
      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            Public: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            Public: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserAuthorityFn", error);
        }
      );
    }
  }, [cookies]);

  return (
    <>
      {hideBarPages &&
        hideBarPages.filter((p) => p === window.location.toString()).length >
        0 ? null : (
        <SideNavBar sidebar={sideNavBar}>
          <Nav className={classes.nav}>
            <ul>
              {moduleCatBinary.Dashboard !== 0 && (
                <Nav.Item>
                  <NavLink to="/Dashboard"
                    onClick={() => setOpenAccordion(null)}
                    className={({ isActive }) =>
                      `${classes.navLink} ${isActive ? classes.activated : ""}`
                    }>
                    <FontAwesomeIcon icon={faGrip} />&nbsp; &nbsp; Dashboard
                  </NavLink>
                </Nav.Item>
              )}

              {moduleCatBinary.Public !== 0 && (
                <Nav.Item>
                  <NavLink to="/holiday"
                    onClick={() => setOpenAccordion(null)}
                    className={({ isActive }) =>
                      `${classes.navLink} ${isActive ? classes.activated : ""}`
                    }>
                    <FontAwesomeIcon icon={faPersonWalkingLuggage} />&nbsp; &nbsp; Gazetted Holiday
                  </NavLink>
                </Nav.Item>
              )}
                
              {moduleCatBinary.Apply !== 0 && (
                <Nav.Item>
                  <Accordion activeKey={openAccordion === 'apply' ? '0' : null} className={classes.accordion}>
                  <Accordion.Item eventKey="0" style={{ border: "none" }}>
                    <Accordion.Header onClick={() =>
                        setOpenAccordion(prev => (prev === 'apply' ? null : 'apply'))
                      } className={classes.accordionheader}>
                      <FontAwesomeIcon icon={faRectangleList} />&nbsp; &nbsp;Apply
                        </Accordion.Header>
                        <Accordion.Body className={classes.transparent}>
                          {CatApply.map((module, index) => {
                            return (moduleCatBinary.Apply &
                              moduleBinary[index]) ===
                              moduleBinary[index] ? (
                              <NavLink
                                to={`${module.key}`}
                                className={({ isActive }) =>
                                  `${classes.navLink} ${isActive ? classes.activated : ""}`
                                }
                                key={`${module.key}`}
                              >
                                {module.title}
                              </NavLink>
                            ) : (
                              <></>
                            );
                          })}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Nav.Item>
                )}

                {moduleCatBinary.History !== 0 && (
                  <Nav.Item>
                    <Accordion activeKey={openAccordion === 'history' ? '0' : null} className={classes.accordion}>
                    <Accordion.Item eventKey="0" style={{ border: "none" }}>
                      <Accordion.Header onClick={() =>
                          setOpenAccordion(prev => (prev === 'history' ? null : 'history'))
                        } className={classes.accordionheader}>
                        <FontAwesomeIcon icon={faNewspaper} />&nbsp; &nbsp;History
                        </Accordion.Header>
                        <Accordion.Body className={classes.transparent}>
                          {CatHistory.map((module, index) => {
                            return (moduleCatBinary.History &
                              moduleBinary[index]) ===
                              moduleBinary[index] ? (
                              <NavLink
                                to={`${module.key}`}
                                className={({ isActive }) =>
                                  `${classes.navLink} ${isActive ? classes.activated : ""}`
                                }
                                key={`${module.key}`}
                              >
                                {module.title}
                              </NavLink>
                            ) : (
                              <></>
                            );
                          })}
                      </Accordion.Body>
                    </Accordion.Item>
                    </Accordion>
                  </Nav.Item>
                )}

                {moduleCatBinary.Users !== 0 && (
                  <Nav.Item>
                    <Accordion activeKey={openAccordion === 'user' ? '0' : null} className={classes.accordion}>
                    <Accordion.Item eventKey="0" style={{ border: "none" }}>
                      <Accordion.Header onClick={() =>
                          setOpenAccordion(prev => (prev === 'user' ? null : 'user'))
                        } className={classes.accordionheader}>
                        <FontAwesomeIcon icon={faUser} />&nbsp; &nbsp; Users
                        </Accordion.Header>
                        <Accordion.Body className={classes.transparent}>
                          {CatUser.map((module, index) => {
                            return (moduleCatBinary.Users &
                              moduleBinary[index]) ===
                              moduleBinary[index] ? (
                              <NavLink
                                to={`${module.key}`}
                                className={({ isActive }) =>
                                  `${classes.navLink} ${isActive ? classes.activated : ""}`
                                }
                                key={`${module.key}`}
                              >
                                {module.title}
                              </NavLink>
                            ) : (
                              <></>
                            );
                          })}
                      </Accordion.Body>
                    </Accordion.Item>
                    </Accordion>
                  </Nav.Item>
                )}

                {moduleCatBinary.MasterSetup !== 0 && (
                  <Nav.Item>
                    <Accordion activeKey={openAccordion === 'master setup' ? '0' : null} className={classes.accordion}>
                    <Accordion.Item eventKey="0" style={{ border: "none" }}>
                      <Accordion.Header onClick={() =>
                          setOpenAccordion(prev => (prev === 'master setup' ? null : 'master setup'))
                        } className={classes.accordionheader}>
                        <FontAwesomeIcon icon={faGears} /> &nbsp; Master Setup
                        </Accordion.Header>
                        <Accordion.Body className={classes.transparent}>
                          {CatMasterSetup.map((module, index) => {
                            return (moduleCatBinary.MasterSetup &
                              moduleBinary[index]) ===
                              moduleBinary[index] ? (
                              <NavLink
                                to={`${module.key}`}
                                className={({ isActive }) =>
                                  `${classes.navLink} ${isActive ? classes.activated : ""}`
                                }
                                key={`${module.key}`}
                              >
                                {module.title}
                              </NavLink>
                            ) : (
                              <></>
                            );
                          })}
                      </Accordion.Body>
                    </Accordion.Item>
                    </Accordion>
                  </Nav.Item>
                )}
            </ul>
          </Nav>
        </SideNavBar>
      )}
    </>
  );
}

export default NavBar;